import React from 'react';
import { Wrench, Truck, Package, Hammer } from 'lucide-react';

export default function WorkDetails({ job }) {
  return (
    <div>
      <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: 'var(--text-primary)',
        marginBottom: '16px'
      }}>
        Work Details
      </h3>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '16px'
      }}>
        {/* Windows */}
        <div style={{
          padding: '12px',
          background: 'rgba(0, 0, 0, 0.02)',
          borderRadius: '8px'
        }}>
          <div style={{
            fontSize: '12px',
            color: 'var(--text-tertiary)',
            marginBottom: '4px',
            fontWeight: '600'
          }}>
            Windows
          </div>
          <div style={{
            fontSize: '20px',
            fontWeight: '700',
            color: 'var(--text-primary)'
          }}>
            {job.windowCount || 0}
          </div>
        </div>

        {/* Doors */}
        <div style={{
          padding: '12px',
          background: 'rgba(0, 0, 0, 0.02)',
          borderRadius: '8px'
        }}>
          <div style={{
            fontSize: '12px',
            color: 'var(--text-tertiary)',
            marginBottom: '4px',
            fontWeight: '600'
          }}>
            Doors
          </div>
          <div style={{
            fontSize: '20px',
            fontWeight: '700',
            color: 'var(--text-primary)'
          }}>
            {job.doorCount || 0}
          </div>
        </div>

        {/* Duration */}
        <div style={{
          padding: '12px',
          background: 'rgba(0, 0, 0, 0.02)',
          borderRadius: '8px'
        }}>
          <div style={{
            fontSize: '12px',
            color: 'var(--text-tertiary)',
            marginBottom: '4px',
            fontWeight: '600'
          }}>
            Duration
          </div>
          <div style={{
            fontSize: '20px',
            fontWeight: '700',
            color: 'var(--text-primary)'
          }}>
            {job.durationDays || 1} day{job.durationDays !== 1 ? 's' : ''}
          </div>
        </div>

        {/* Job Type */}
        <div style={{
          padding: '12px',
          background: 'rgba(0, 0, 0, 0.02)',
          borderRadius: '8px'
        }}>
          <div style={{
            fontSize: '12px',
            color: 'var(--text-tertiary)',
            marginBottom: '4px',
            fontWeight: '600'
          }}>
            Type
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '600',
            color: 'var(--text-primary)',
            textTransform: 'capitalize'
          }}>
            {job.isRepair && <><Wrench size={14} strokeWidth={2.25} /> Repair</>}
            {job.isDeliveryOnly && <><Truck size={14} strokeWidth={2.25} /> Delivery</>}
            {job.isPickupAtShop && <><Package size={14} strokeWidth={2.25} /> Pickup</>}
            {!job.isRepair && !job.isDeliveryOnly && !job.isPickupAtShop && <><Hammer size={14} strokeWidth={2.25} /> Install</>}
          </div>
        </div>
      </div>

      {/* Notes Section */}
      {(job.notes || job.internalNotes) && (
        <div style={{ marginTop: '16px' }}>
          {job.notes && (
            <div style={{ marginBottom: '12px' }}>
              <div style={{
                fontSize: '13px',
                fontWeight: '600',
                color: 'var(--text-primary)',
                marginBottom: '6px'
              }}>
                Customer Notes:
              </div>
              <div style={{
                fontSize: '14px',
                color: 'var(--text-secondary)',
                padding: '12px',
                background: 'rgba(59, 130, 246, 0.05)',
                borderRadius: '8px',
                border: '1px solid rgba(59, 130, 246, 0.1)',
                whiteSpace: 'pre-wrap'
              }}>
                {job.notes}
              </div>
            </div>
          )}

          {job.internalNotes && (
            <div>
              <div style={{
                fontSize: '13px',
                fontWeight: '600',
                color: 'var(--text-primary)',
                marginBottom: '6px'
              }}>
                Internal Notes:
              </div>
              <div style={{
                fontSize: '14px',
                color: 'var(--text-secondary)',
                padding: '12px',
                background: 'rgba(249, 115, 22, 0.05)',
                borderRadius: '8px',
                border: '1px solid rgba(249, 115, 22, 0.1)',
                whiteSpace: 'pre-wrap'
              }}>
                {job.internalNotes}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}